import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import "./index.css";

const useStyles = makeStyles({
  noDropdownIcon: {
    "& .MuiAutocomplete-endAdornment": {
      display: "none",
    },
  },
});

function FormAutocomplete(props) {
  const classes = useStyles();
  const { control, errors } = useFormContext();
  const {
    name,
    required,
    variant,
    defaultValue = "",
    options,
    handleChange,
    InputLabelProps,
    noOptionsText = "No results found.",
    ...rest
  } = props;

  let isError = false;
  let errorMessage = "";
  if (errors && errors.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errors[name].message;
  }

  const optionsFirstLetter = options.map((option) => {
    const firstLetter = option.value[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  const valueCheck = (value) => {
    if (typeof value === "object" && value !== null) {
      return value.value || "";
    }
    return value || "";
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ value, onChange }) => (
        <Autocomplete
          {...rest}
          value={
            options.find((option) => option.value === valueCheck(value)) || null
          }
          onChange={(event, newValue) => {
            if (newValue) {
              handleChange(name, newValue.value);
              onChange(newValue.value);
            } else {
              handleChange(name, null);
              onChange(null);
            }
          }}
          options={optionsFirstLetter.sort(
            (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
          )}
          groupBy={(option) => option.firstLetter}
          getOptionLabel={(option) => option.value || ""}
          getOptionSelected={(option, value) =>
            option.value === valueCheck(value)
          }
          noOptionsText={noOptionsText}
          classes={{ root: classes.noDropdownIcon }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={variant || "outlined"}
              error={isError}
              helperText={errorMessage}
              InputLabelProps={{
                className: required ? "required-label" : "",
                required: required || false,
                ...InputLabelProps,
              }}
            />
          )}
        />
      )}
    />
  );
}

export default FormAutocomplete;
